const USER_ROLES = [
    {name: 'суперадминистратор', value: 1},
    {name: 'администратор', value: 2},
    {name: 'модератор', value: 3},
    {name: 'супермодератор', value: 6},
]

export { USER_ROLES }